import { render, staticRenderFns } from "./CardDiagnosis.vue?vue&type=template&id=4746761c&scoped=true"
import script from "./CardDiagnosis.vue?vue&type=script&lang=js"
export * from "./CardDiagnosis.vue?vue&type=script&lang=js"
import style0 from "./CardDiagnosis.vue?vue&type=style&index=0&id=4746761c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4746761c",
  null
  
)

export default component.exports